var _templateObject, _templateObject2, _templateObject3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { Icon, IconImage } from '@finect/tabular-components/Icon';
import { isMobile } from '@finect/front-utils/isMobile';
import { IconAction } from '../partials/IconAction';
import { UserMenu } from '../UserMenu';
import { IconMenuNav, IconMenuNavInner } from '../partials/IconMenuNav';
const UserActionContent = styled.div.withConfig({
  displayName: "UserAction__UserActionContent",
  componentId: "sc-7pe1lu-0"
})(["position:relative;user-select:none;", "{> svg{display:none;}", ";}", ";"], IconAction, maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      min-width: none;\n      max-width: none;\n      max-width: 200px;\n\n      ", " {\n        border-radius: ", ";\n\n        img {\n          border-radius: ", ";\n        }\n      }\n\n      > svg {\n        display: block;\n        position: static;\n        transform: none;\n      }\n    "])), IconImage, _ref => {
  let {
    theme
  } = _ref;
  return "".concat(theme.borderRadius, " 0 0 ").concat(theme.borderRadius);
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return "".concat(theme.borderRadius, " 0 0 ").concat(theme.borderRadius);
}), minMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    &:hover {\n      nav {\n        visibility: visible;\n        opacity: 1;\n        transform: translateY(0);\n        transition: opacity 0.25s 0s ease,\n          transform 0.25s 0s cubic-bezier(0.49, 0.42, 0.52, 0.98),\n          visibility 0s 0s ease;\n        transition-delay: 0.15s;\n      }\n\n      ", " {\n        max-width: 200px;\n      }\n    }\n  "])), IconAction));
const UserName = styled.span.withConfig({
  displayName: "UserAction__UserName",
  componentId: "sc-7pe1lu-1"
})(["padding:0 8px;", ";"], maxMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
export const UserAction = _ref3 => {
  let {
    user,
    toggleMobileMenu,
    finectApp
  } = _ref3;
  const {
    displayName,
    icon
  } = user;
  const handleClick = () => {
    if (window.innerWidth >= 640) return;
    toggleMobileMenu();
  };
  const handleDocumentTouchStart = () => {
    document.removeEventListener('touchstart', handleDocumentTouchStart);
  };
  const handleTouchStart = () => {
    document.addEventListener('touchstart', handleDocumentTouchStart);
  };
  const props = isMobile() ? {
    onTouchStart: handleTouchStart
  } : {};
  return React.createElement(UserActionContent, {
    "aria-haspopup": "true"
  }, React.createElement(IconAction, _extends({
    onClick: handleClick,
    withBackground: false,
    noPadding: true,
    opened: "true"
  }, props), React.createElement(Icon, {
    alt: displayName,
    image: icon ? "/image/".concat(icon) : '',
    fill: icon ? 'transparent' : '#ff5277',
    size: 1,
    small: true
  }), React.createElement(UserName, null, displayName)), React.createElement(IconMenuNav, null, React.createElement(IconMenuNavInner, null, React.createElement(UserMenu, {
    user: user,
    finectApp: finectApp
  }))));
};